export const API_ROUTES = {
  SETUP_STATUS: {
    METHOD: 'GET',
    URL: 'general_setting/setup_status',
  },
  LOGO_UPLOAD_URL: {
    METHOD: 'POST',
    URL: 'general_setting/logo/upload-url',
  },
};

/**
 * Cache key for the gate. Exported so a step can invalidate it after saving
 * without importing the layout that owns the query.
 */
export const SETUP_STATUS_QUERY_KEY = ['tenantSetupStatus'];

/**
 * The wizard's steps, in order. `key` matches the corresponding block in the
 * status payload, so the stepper can mark a step done from the server's answer
 * rather than from whatever the user happens to have typed.
 */
export const ONBOARDING_STEPS = [
  {
    key: 'general',
    label: 'Company details',
    description:
      'Your company identity. It appears on every invoice and quotation you send.',
  },
  {
    key: 'integration',
    label: 'Integrations',
    description:
      'Email and payment credentials. Without these the system cannot send mail or take payments.',
  },
];
